<mat-toolbar color="primary">
  <button mat-icon-button  (click)="toggleSideBar()">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="center-vertical">
    <img src="/assets/images/logoNegos.svg" alt="Logo Negos">
  </span>

  <span class="topbar-spacer"></span>
    <button mat-button [matMenuTriggerFor]="menu"><mat-icon [matBadge]="this.countNotification" matBadgeColor="warn">notifications</mat-icon></button>
    
    <mat-menu #menu="matMenu" xPosition="after">

      <div class="side-padding" *ngFor="let notification of this.notifications" style="min-width: 240px;">
    
        <h3 class="margin-tittle">{{ notification.tipoProceso }} <span style="float: right;
          margin-right: 19px; font-size: 12px;">ID: {{ notification.idProceso }}</span></h3>
        <p><b>Cantidad de negos:</b> {{ notification.cantidadNegos }}</p>

        <div style="padding-left: 8px;">
          <p>Resultados</p>
          <div *ngFor="let result of notification.resultado">
            <p style="margin: 0px;"><b>Estado: </b>{{ result.estado }}</p>
            <p style="margin: 0px;"><b>Cantidad: </b>{{ result.cantidadNegos }}</p>
          </div>
        </div> 
        <div style="text-align: right; color: blue; margin-top: 2px;">
          <button mat-button style="font-size: 13px;" (click)="onlySee(notification.idProceso)">Ver</button>
          <button mat-button style="font-size: 13px;"  (click)="onlyMarkRead(notification.idProceso)">Marcar leido</button>
        </div>
        <hr class="separador-notification">
      </div>
      
      <div *ngIf="this.countNotification == 0" class="side-padding">
        <p>No se encontraron notificaciones</p>
      </div>

    </mat-menu>

    <img class="topbar-logo" src="{{user.photoUrl}}" alt="" srcset="">
    <a class="topbar-link" >{{user.firstName}}:{{roles}}</a>
</mat-toolbar>
